<template>
  <v-list class="pa-0">
    <v-list-item
      v-for="(item, index) in defecations"
      :key="item.defecationId || index"
      class="border-bottom"
    >
      <div class="d-flex align-center justify-space-between w-100 py-3">
        <div class="d-flex align-center">
          <p class="grey--text text--darken-1 mb-0 mr-3">
            {{ minuteFormat(item.recordedAt) }}
          </p>
          <p class="mb-0">{{ getDefecationState(item.state) }}</p>
        </div>

        <v-btn
          icon
          variant="text"
          color="red"
          @click="deleteItem(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
    </v-list-item>
  </v-list>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import { when } from '@/service/Switch';

import { dailyReportModule } from '@/store/entityModules/dailyReport';

import {
  DefecationStatus,
  DefecationStatusType,
} from '../../../../node_modules/chaild-entity/src/component/home/defecation/types';
import { DefecationResponse } from '@API/src/component/home/defecation/types';
/*
import {
  SwipeList,
  SwipeOut,
} from 'vue-swipe-actions';
 */
import { Toast } from '@/service/SweetAlert';
//import 'vue-swipe-actions/dist/vue-swipe-actions.css';
import { SwipeListModel } from '@/model/SwipeList/SwipeList';

interface DataType {
  loading: false;
}

export default defineComponent({

  components: {
   // wipeOut,
   //SwipeList,
  },

  props: {
    defecations: {
      type: Array,
      default: () => ([]),
    },
  },

  computed: {
    swipeList(): SwipeListModel {
      return (this.$refs as any).defecation_swipe_list;
    },
  },

  data: (): DataType =>({
    loading: false,
  }),

  methods: {
    minuteFormat(iso: string) {
      return dayjs(iso).format('HH:mm');
    },
    revealFirstRight(index, revealed) {
      if (!revealed) {
        this.swipeList.revealRight(index);
      } else {
        this.swipeList.closeActions(index);
      }
    },
    revealFirstLeft() {
      this.swipeList.revealLeft(0);
    },
    closeFirst() {
      this.swipeList.closeActions(0);
    },
    closeAll() {
      this.swipeList.closeActions();
    },
    getDefecationState(state: DefecationStatusType): string {
      return when(state)
        .on((v) => v === DefecationStatus.hard, () => '硬い')
        .on((v) => v === DefecationStatus.normal, () => '普通')
        .on((v) => v === DefecationStatus.soft, () => '軟らかい')
        .on((v) => v === DefecationStatus.diarrhea, () => '水様便（下痢）')
        .otherwise(() => '');
    },
    async deleteItem(e: DefecationResponse) {
      Swal.fire({
        title: '<span style="font-size: 23px;">記録を削除しますか?</span>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#FF3F3A',
        cancelButtonColor: '#BDBDBD',
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.showLoading();
          await dailyReportModule.deleteDefecation({ defecationId: e.defecationId });
          Toast.fire({
            icon: 'success',
            title: '削除が完了しました',
          });
        }
      });
    },
    itemClick(e) {},
    fbClick(e) {},
    sbClick(e) {},
  },

});
</script>
<style lang="scss" scoped>

</style>
